//@ts-nocheck
import { useContext, useRef, useState } from "react";
import { Typography } from "mobily-ui-library/lib";
import { useTranslation } from "react-i18next";

import Store from "../Store/Store";
import StoreCluster from "../StoreCluster/StoreCluster";
import StoreLoader from "../Store/StoreLoader/StoreLoader";
import { getStoreLocator } from "../../api/api";
import { Error } from "../../util/Util";
import { GlobalContext } from "../../context/GlobalContext";
import Loader from "../Loader/Loader";
import { useWindowSize } from "../../util/WindowResize";

import "./Home.scss";

type HomeProps = {
  rtl: boolean;
};

const win: any = window;
const key = win['googleMapKey']

function Home(props: HomeProps) {
  const { rtl } = props;
  const { t } = useTranslation();
  const center = { lat: 24.7135517, lng: 46.6752957 };
  const [storeData, setStoreData] = useState([]);
  const [checked, setChecked] = useState({ openNow: false, selfService: false, disabilityFriendly: false });
  const [mode, setMode] = useState(false);
  const [stLoading, setStLoading] = useState(false);
  const { state, dispatch }: any = useContext(GlobalContext);
  const { width } = useWindowSize();
  const childRef: any = useRef();

  const handleAddress = (dimension: any, location: any) => {
    setStLoading(true);
    if (location === "all") {
      setMode(true);
      getStoreLocator(location)
        .then((res) => {
          if (res.status === 200 && res.data.data.mobilyStores.length > 0) {
            setStoreData(res.data.data.mobilyStores);
            setStLoading(false);
          } else {
            setStoreData([]);
            setStLoading(false);
            Error(
              rtl ? res.data.status.arabicDetail : res.data.status.englishDetail
            );
          }
        })
        .catch((err) => Error(err));
    } else {
      const data: any = {
        cityName: location,
        lat: dimension.lat,
        lon: dimension.lng,
      };

      getStoreLocator(data)
        .then((res) => {
          if (res.status === 200 && res.data.data.mobilyStores.length > 0) {
            setMode(false);
            setStoreData(res.data.data.mobilyStores);
            setStLoading(false);
          } else {
            handleAddress(center, "all");
            setMode(false);
          }
        })
        .catch((err) => Error(err));
    }
  };

  const handleCheckedChange = (name: string) => {
    setChecked(prev => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  let storeList: any = storeData;

  storeList = storeData.filter((store: any) => {
    const openNowMatch = !checked.openNow || (rtl ? store.storeStatus.label.ar === "مفتوح" : store.storeStatus.label.en.toLowerCase() === "open");
    const disabilityMatch = !checked.disabilityFriendly || store?.disabilityFriendly === "True";
    const selfServiceMatch = !checked.selfService || store?.ssk === "True";
    return openNowMatch && disabilityMatch && selfServiceMatch;
  });

  const handleListClick = (index) => {
    const refValue = childRef.current;
    refValue.listItemClick(index);
  };

  return (
    <>
      <div
        className={
          rtl
            ? "container Home__Container Home__arbaic"
            : "container Home__Container"
        }
      >
        <div className="row">
          <Typography rtl={rtl} className="HC__title">
            {t("Store_title")}
          </Typography>
          <Typography rtl={rtl} className="HC__subTitle">
            {t("Store_subtitle")}
          </Typography>
          <div className="HC__StoreContainer">
            {stLoading && <StoreLoader stLoading={stLoading} />}
            <Store
              rtl={rtl}
              checked={checked}
              storeList={storeList}
              handleCheckedChange={handleCheckedChange}
              handleListClick={handleListClick}
            />

            <StoreCluster
              ref={childRef}
              checked={checked}
              storeData={storeList}
              rtl={rtl}
              dispatch={dispatch}
              center={center}
              handleAddress={handleAddress}
              width={width}
              mode={mode}
              {...props}
            />
          </div>
        </div>
      </div>

      <Loader loading={state.loader} />
    </>
  );
}

export default Home;
